import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import uploadIcon from "../../Assets/svg/upload-icon.svg";
import downloadIcon from "../../Assets/svg/download-icon.svg";
import { useGlobal } from "../../GlobalContext.js";
import { apiCall } from "../../services/api-service.js";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";
import DeleteModal from "../common/DeleteModal";
import { useExcelActions } from "../../hooks/useExcelActions";

const Projectlist = () => {
  const { rolePermissionList } = useGlobal();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [projectList, setProjectList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10); // or any default value
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);


  const getListData = async (term, skip = itemOffset) => {
    const response = await apiCall("get", "project", null, {
      params: {
        limit: itemsPerPage,
        skip,
        search: term,
        status: status,
      },
    });
    if (response?.status === 200 && response.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setProjectList(response.data.projects ?? []);

      // Snap back to the last page if the current page is now out of range.
      const currentPage = Math.floor(skip / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
  };

  const {
    uploadLoading,
    templateLoading,
    reportLoading,
    handleFileUpload,
    downloadTemplate,
    downloadReport,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    isDragging,
  } = useExcelActions("project", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "projects");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [status] = useState("All");

  function checkPermission(menuName, permission) {
    return rolePermissionList.some(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    );
  }

  useEffect(() => {
    getListData(searchTerm);
    // searchTerm is intentionally omitted: the debounced handleSearch in the
    // input's onChange drives search fetches. Including it here would fire a
    // second, undebounced fetch on every keystroke.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, itemsPerPage, itemOffset]);
  /* const pageCount = Math.ceil(teamList.length / itemsPerPage); */

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const [deleteId, setDeleteId] = useState(null);
  const deleteTeam = async (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };
  const deleteApi = async () => {
    if (deleteId != null) {
      const response = await apiCall("delete", `project/${deleteId}`);
      if (response?.status === 200 && response.data?.success === true) {
        setDeleteId(null);
        setIsOpenDelete(false);
        getListData("");
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    }
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    // A new search starts from the first page. If already on page 1, fetch
    // directly; otherwise reset the offset and let the itemOffset effect fetch.
    if (itemOffset === 0) {
      getListData(term, 0);
    } else {
      setItemOffset(0);
    }
  }, 1000);

  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Project
                    </span>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your project list here
                    </div>
                  </div>
                </div>
                <div
                  style={{ display: "flex", gap: "12px", alignItems: "center" }}
                >
                  <div
                    onClick={() => !uploadLoading && fileInputRef.current.click()}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                      height: "40px",
                      borderRadius: "100px",
                      padding: "8px 16px",
                      gap: "8px",
                      backgroundColor: isDragging ? "#F0E9FF" : "#FFFFFF",
                      border: isDragging ? "2px dashed #6929E2" : "1px solid #E5E5E5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: uploadLoading ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept=".xlsx, .xls"
                      style={{ display: "none" }}
                    />
                    {uploadLoading ? (
                      <div className="spinner"></div>
                    ) : (
                      <img
                        src={uploadIcon}
                        alt="excel"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                    <p
                      style={{
                        margin: "0",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#212129",
                      }}
                    >
                      Upload
                    </p>
                  </div>
                  
                  <div
                    onClick={downloadTemplate}
                    style={{
                      height: "40px",
                      borderRadius: "100px",
                      padding: "8px 16px",
                      gap: "8px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E5E5E5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {templateLoading ? (
                      <div className="spinner"></div>
                    ) : (
                      <img
                        src={downloadIcon}
                        alt="template"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                    <p
                      style={{
                        margin: "0",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#212129",
                      }}
                    >
                      Template
                    </p>
                  </div>
                  {checkPermission("Project", "create_permission") && (
                    <Link to="/project/add" style={{ textDecoration: "none" }}>
                      <div
                        style={{
                          height: "40px",
                          borderRadius: "100px",
                          padding: "8px 16px 8px 16px",
                          gap: "8px",
                          backgroundColor: "#6929E2",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: "0",
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#FFFFFF",
                          }}
                        >
                          + Add project
                        </p>
                      </div>
                    </Link>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total projects: {totalCount}
                  </p>
                </div>

                <div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <div>
                    <input
                      type="search"
                      placeholder="Search projects"
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      style={{
                        width: "300px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.5px solid #E5E5E5",
                        padding: "14px 16px 14px 16px",
                        gap: "6px",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </div>
                  <ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ status, search: searchTerm })}
                  />
                </div>
              </div>

              <div
                style={{
                  borderRadius: "8px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    height: "42px",
                    flex: "12",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px 12px 16px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Code
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "3",
                    }}
                  >
                    Name
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Project Admin
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Project Manager
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Team
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "1",
                    }}
                  ></span>
                </div>
                <div>
                  {projectList.map((item, index) => (
                    <div
                      key={"table-list" + index}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      <div
                        style={{
                          height: "40px",
                          flex: "10",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "12px 16px 12px 16px",
                          backgroundColor: "#FFFFFF",
                          borderBottom: "0.6px solid #D4DDE7",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "2",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.code}
                        </span>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "3",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.name}
                        </span>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "2",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.admin || "-"}
                        </span>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "2",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.manager || "-"}
                        </span>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "2",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                          title={item.users ?? "-"}
                        >
                          {item.users || "-"}
                        </span>

                        <div
                          style={{
                            flex: "1",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {checkPermission("Project", "edit_permission") && (
                              <div
                                onClick={() => {
                                  navigate("/project/add", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={edit}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}

                            {checkPermission(
                              "Project",
                              "delete_permission"
                            ) && (
                                <div
                                  onClick={() => {
                                    deleteTeam(item.id);
                                  }}
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100px",
                                    gap: "10px",
                                    backgroundColor: "#FFFFFF",
                                  }}
                                >
                                  <img
                                    src={dt}
                                    style={{ width: "14px", height: "14px" }}
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemsPerPage(n);
                    setItemOffset(0);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete Project"
        message="You won’t able to access your project after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                       <strong className="mr-auto">Snackbar Title</strong>
                                     </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Projectlist;
